module.exports = __webpack_public_path__ + "media/img/event/Virtual-Scholarship-Fair-2020-Feature-Layer-02-7f9210765e7c1c316df52dc9a9407975.svg";